import React, { Component } from "react";
import PropTypes from "prop-types";
import "./CircleImage.css";

export class CircleImage extends Component {
  handleMouseEnter = () => {
    const { enlargeOnHover } = this.props;
    if (enlargeOnHover) {
      this.circleImageRef.style.transform = "scale(1.2)";
    }
  };

  handleMouseLeave = () => {
    const { enlargeOnHover } = this.props;
    if (enlargeOnHover) {
      this.circleImageRef.style.transform = "scale(1)";
    }
  };

  handleClick = () => {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
  };

  handleImageError = (e) => {
    const { fallbackSrc } = this.props;
    if (!fallbackSrc) return;

    if (e?.currentTarget?.src !== fallbackSrc) {
      e.currentTarget.src = fallbackSrc;
    }
  };

  render() {
    const { src, alt, size, imageStyle } = this.props;

    return (
      <div
        className="circle-image"
        style={{ width: size, height: size }}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleClick}
        ref={(ref) => (this.circleImageRef = ref)}
      >
        <img src={src} alt={alt} onError={this.handleImageError} style={imageStyle} />
      </div>
    );
  }
}

CircleImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  size: PropTypes.string,
  enlargeOnHover: PropTypes.bool,
  fallbackSrc: PropTypes.string,
  imageStyle: PropTypes.object,
  onRedirect: PropTypes.func,
};

CircleImage.defaultProps = {
  alt: "circle image",
  size: "45px",
  enlargeOnHover: false,
  fallbackSrc: "",
  imageStyle: undefined,
  onRedirect: null,
};
